import React from 'react';
import './Toast.css';

// Deriva o tipo do toast a partir do prefixo emoji usado hoje nas mensagens,
// ou de um `type` explícito. Mantém uma única fonte de estilo/ícone/ARIA
// para todo feedback de API (upload, sync, backup, rollback).
export function inferToastType(message = '') {
  const text = String(message);
  if (text.startsWith('✅')) return 'success';
  if (text.startsWith('❌')) return 'error';
  if (text.startsWith('⚠️')) return 'warning';
  return 'info';
}

const ICONS = {
  success: 'M20 6L9 17l-5-5',
  error: 'M18 6L6 18M6 6l12 12',
  warning: 'M12 9v4M12 17h.01M10.3 3.9L2 18a1 1 0 0 0 .9 1.5h18.2A1 1 0 0 0 22 18L13.7 3.9a1 1 0 0 0-3.4 0z',
  info: 'M12 16v-4M12 8h.01M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z',
};

export function stripToastPrefix(message = '') {
  return String(message).replace(/^([✅❌⚠️ℹ️]+)\s*/, '').trim();
}

export default function Toast({ message, type, actionLabel, onAction }) {
  if (!message) return null;
  const kind = type || inferToastType(message);
  const text = stripToastPrefix(message);
  // Erros e avisos interrompem o leitor de tela; progresso/sucesso são polidos.
  const role = kind === 'error' || kind === 'warning' ? 'alert' : 'status';
  return (
    <div className={`toast toast--${kind}`} role={role}>
      <svg
        className="toast__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d={ICONS[kind]} />
        {kind === 'warning' ? null : null}
      </svg>
      <span className="toast__text">{text}</span>
      {actionLabel && onAction ? (
        <button type="button" className="toast__action" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
